export function isResourceUnavailable (err) {
    return !!(err && String(err.code) === '-1006')
}

export const RESOURCE_UNAVAILABLE_TEXT = '该资源已下架或暂无内容'
